/**
 * Règles générales de la société (administration).
 * `GET` est lisible par tout utilisateur authentifié : le front doit connaître
 * la règle qui le contraint. L'écriture est réservée aux administrateurs
 * (le serveur est l'autorité).
 */
import { instance } from './axios.instance';

const BASE = '/company_settings';

/** Promesse mémoïsée : l'app classique et le web-editor lisent les mêmes
 *  règles, un seul GET suffit pour la durée de la page. */
let rulesPromise = null;

/** Charge les règles. Toute erreur (route absente, 403, réseau) donne `{}` :
 *  une règle inconnue ne doit bloquer personne. */
export function fetchGlobalRules() {
  if (!rulesPromise) {
    rulesPromise = instance
      .get(BASE)
      .then((res) => res.data?.rules || {})
      .catch(() => ({}));
  }
  return rulesPromise;
}

/** Met à jour une partie des règles (merge côté serveur) et rafraîchit le cache. */
export async function updateGlobalRules(patch) {
  const res = await instance.patch(BASE, { rules: patch });
  const rules = res.data?.rules || {};
  rulesPromise = Promise.resolve(rules);
  return rules;
}

/** Vide le cache — utile aux tests et après un changement de compte. */
export function resetGlobalRulesCache() {
  rulesPromise = null;
}
